import Vue from 'vue'
import Router from 'vue-router'
import CallerCalendar from "@/views/rufbereitschaft/CallerCalendar";

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

const Calendar = () => import('@/views/calendar/calendar')

const RufbereitschaftRaster = () => import('@/views/rufbereitschaft/Raster')
const RufbereitschaftCalendar = () => import('@/views/rufbereitschaft/RbCalendar')
const RufbereitschaftSettings = () => import('@/views/rufbereitschaft/RbSettings')
const RufbereitschaftCaller = () => import('@/views/rufbereitschaft/CallerCalendar')
const Anwesenheit = () => import('@/views/zeitkontrolle/Anwesenheit.vue')
const Azra = () => import('@/views/basis_data/azra_list.vue')
const Breaks = () => import('@/views/basis_data/break_list.vue')
const Migrs = () => import('@/views/basis_data/migr_list.vue')
const Kosts = () => import('@/views/basis_data/kost_list.vue')
const Mitas = () => import('@/views/basis_data/mita_list.vue')
const Lohns = () => import('@/views/basis_data/lohn_list.vue')
const AzraDetail = () => import('@/views/basis_data/azra_detail.vue')

const UebSettings = () => import('@/views/zeitkontrolle/UebSettings.vue')


Vue.use(Router);

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      //redirect: '/',
      name: 'Personalwesen',
      component: DefaultContainer,
      children: [
        {
          path: 'bookings',
          redirect: '/bookings/calendar',
          name: 'Kalender',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "calendar",
              name: 'Kalender',
              component: Calendar
            },
            {
              path: "anwesenheit",
              name: 'Anwesenheit',
              component: Anwesenheit
            },
          ],
        },
        {
          path: 'zeitkontrolle',
          redirect: '/zeitkontrolle/anwesenheit',
          name: 'Anwesenheit',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "anwesenheit",
              name: 'Anwesenheit',
              component: Anwesenheit
            },
          ],
        },
        {
          path: 'zeitkontrolle',
          redirect: '/zeitkontrolle/anwesenheit',
          name: 'Anwesenheit',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "anwesenheit",
              name: 'Anwesenheit',
              component: Anwesenheit
            },
            {
              path: "settings",
              name: 'Einstellungen',
              component: UebSettings
            },
          ],
        },
        {
          path: 'rb',
          redirect: '/rb/raster',
          name: 'Rufbereitschaft',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "raster",
              name: 'Raster',
              component: RufbereitschaftRaster
            },
            {
              path: "calendar",
              name: 'Kalender',
              component: RufbereitschaftCalendar
            },
            {
              path: "caller",
              name: 'Rufer',
              component: RufbereitschaftCaller
            },
            {
              path: "settings",
              name: 'Einstellungen',
              component: RufbereitschaftSettings
            },
          ],
        },
        {
          path: 'basis',
          redirect: '/basis/azra',
          name: 'Stammdaten',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: "azra",
              name: 'Arbeitszeitraster',
              component: Azra
            },
            {
              path: "azra/:id",
              name: 'Arbeitszeitraster Details',
              component: AzraDetail
            },
            {
              path: "breaks",
              name: 'Pausen',
              component: Breaks
            },
            {
              path: "kost",
              name: 'Kostenstellen',
              component: Kosts
            },
            {
              path: "migr",
              name: 'Mitarbeitergruppen',
              component: Migrs
            },
            {
              path: "mita",
              name: 'Mitarbeiter',
              component: Mitas
            },
            {
              path: "lohn",
              name: 'Lohnarten',
              component: Lohns
            },
          ],
        },
      ]
    },
  ]
})
